// Keep this small browser helper identical in agent and caller. Neither app
// may wait for a backend/microphone promise before requesting RTC disconnect.
export const disconnectCallMedia = (room, microphoneTrack, reason = "hangup") => {
  const requestedAtMs = Date.now();
  const started = performance.now();
  const tracks = new Set([microphoneTrack]);
  room?.localParticipant?.trackPublications?.forEach((publication) => {
    if (publication.track) tracks.add(publication.track);
  });
  for (const track of tracks) {
    try {
      if (track?.mediaStreamTrack) track.mediaStreamTrack.enabled = false;
      track?.stop?.();
    } catch (_) {
      // A broken/stale track cannot prevent room.disconnect().
    }
  }
  const timing = {requestedAtMs, reason};
  let disconnected;
  try {
    disconnected = Promise.resolve(room?.disconnect?.());
  } catch (error) {
    disconnected = Promise.reject(error);
  }
  let timeout;
  const outcome = disconnected.then(() => ({
      ...timing, disconnected: true, disconnectedAtMs: Date.now(),
      disconnectDurationMs: performance.now() - started,
    }), () => ({
      ...timing, disconnected: false,
      disconnectDurationMs: performance.now() - started,
    }));
  return {
    timing,
    done: Promise.race([outcome, new Promise((resolve) => {
      timeout = setTimeout(() => resolve({
        ...timing, disconnected: false,
        disconnectDurationMs: performance.now() - started,
      }), 5000);
    })]).finally(() => clearTimeout(timeout)),
  };
};
